import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {AuthService} from '../../../services/auth/auth.service';
import {LeftNavbarService} from '../../../services/left-navbar/left-navbar.service';
import {User} from '../../../models/user';
import {RouterLink} from '@angular/router';
import { NgOptimizedImage } from '@angular/common';
import {ImageService} from '../../../services/image/image.service';
import {UserActivityService} from '../../../services/user-activity/user-activity.service';

@Component({
  selector: 'app-top-navbar',
  imports: [
    RouterLink,
    NgOptimizedImage
],
  templateUrl: './top-navbar.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './top-navbar.component.scss'
})
export class TopNavbarComponent implements OnInit {

  connectedUser: User | null = null;

  constructor(
    protected imageService: ImageService,
    private auth: AuthService,
    private leftNavbarService: LeftNavbarService,
    private userActivity: UserActivityService,
  ) {
  }

  ngOnInit(): void {
    this.auth.getConnectedUser().subscribe((connectedUser: User) => {
      this.connectedUser = connectedUser;
    });
  }

  logout(): void {
    this.userActivity.logLogout();
    this.auth.logout();
  }

  toggle(): void {
    this.leftNavbarService.toggle();
  }
}
